module.exports = __webpack_public_path__ + "img/dentalfit_11_a.5b559aa7.jpg";